import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient } from '@tanstack/react-query';

/*
 Default options [skip for now]
 {
  defaultOptions: {
    queries: {
      staleTime: 0.5 * (60 * 1000), // 30 seconds
      gcTime: 5 * (60 * 1000), // 5 mins
    },
  },
}
*/

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1 * (10 * 1000), // 10 seconds
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
});
